import React, { useState, useRef } from 'react';

import { useTranslation } from "react-i18next";

const AddWalletForm = ({ onClose, onSubmit }) => {
  const { t } = useTranslation("exchange");

  const [newWallet, setNewWallet] = useState({
    address: '',
    name: ''
  });

  const input1Ref = useRef(null);

  const handleAddressChange = (e) => {
    const address = e.target.value.trim();
    setNewWallet(prev => ({ ...prev, address }));
  };

  const handleNameChange = (e) => {
    const name = e.target.value;
    setNewWallet(prev => ({ ...prev, name }));
  };

  const handleSubmit = () => {
    if (isFormValid()) {
      const walletToAdd = {
        id: Date.now(),
        address: newWallet.address,
        name: newWallet.name,
        masked_address: maskAddress(newWallet.address),
        type: 'USDT TRC-20'
      };
      
      onSubmit(walletToAdd);
      setNewWallet({ address: '', name: '' });
    }
  };

  const maskAddress = (address) => {
    if (!address || address.length < 8) return address;
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  const isFormValid = () => {
    return (
      newWallet.address.length >= 20 && 
      newWallet.name.trim().length > 0
    );
  };

  const isValidAddress = (address) => {
    // Базовая валидация для TRON адресов (начинается с T и длина 34 символа)
    return /^T[A-Za-z0-9]{33}$/.test(address);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg flex flex-col">
        {/* Шапка */}
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold text-gray-800">
            {t("ADD_NEW_WALLET")}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl font-bold w-6 h-6 flex items-center justify-center"
          >
            ×
          </button>
        </div>
    
        {/* Контент */}
        <div className="flex-1 overflow-y-auto p-4">
          {/* Превью кошелька */}
          {newWallet.address && (
            <div className="mb-4 p-3 bg-gray-50 rounded-lg border">
              <div className="flex items-center gap-3">
                <div className="w-10 h-7 rounded-md bg-green-500 flex items-center justify-center text-white font-bold text-sm">
                  ₮
                </div>
                <div className="flex flex-col gap-0.5">
                  <span className="text-sm font-semibold text-gray-800">
                    {maskAddress(newWallet.address)}
                  </span>
                  <span className="text-xs text-gray-500">USDT TRC-20</span>
                </div>
                {newWallet.name && (
                  <span className="text-xs text-gray-500 ml-auto">
                    {newWallet.name}
                  </span>
                )}
              </div>
              {!isValidAddress(newWallet.address) &&
                newWallet.address.length > 0 && (
                  <div className="text-xs text-red-500 mt-2">
                    {t("ADDRESS_SHOULD_START_AND_CONTAIN")}
                  </div>
                )}
            </div>
          )}
  
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                {t("WALLET_ADDRESS")}*
              </label>
              <input
                type="text"
                value={newWallet.address}
                onChange={handleAddressChange}
                placeholder="TCRYPToiPYHfZpq4bv8sDtLrcDwhUKrdNW"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors font-mono text-sm !text-black"
                maxLength="34"
                enterKeyHint="next"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      if (newWallet.address.length === 34)
                        input1Ref.current?.focus();
                    }
                  }}
              />
              <div className="text-xs text-gray-500 mt-1">
                {newWallet.address.length}/{t("34_SYMBOLS")}
              </div>
            </div>
        
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1 !text-black">
                {t("WALLET_NAME")}*
              </label>
              <input
                ref={input1Ref}
                type="text"
                value={newWallet.name}
                onChange={handleNameChange}
                placeholder="Основной кошелек, Для торговли..."
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors !text-black"
                maxLength="20"
                enterKeyHint="go"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      if(!isFormValid() || !isValidAddress(newWallet.address)) return;
                      handleSubmit();
                    }
                  }}
              />
              <div className="text-xs text-gray-500 mt-1">
                {newWallet.name.length}/{t("20_SYMBOLS")}
              </div>
            </div>
        
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <div className="flex items-start gap-2">
                <div className="text-xs text-blue-700">
                  <div className="font-medium mb-1">{t("SUPPORTED_NETWORKS")}:</div>
                  <div>USDT TRC-20 (Tron Network)</div>
                  <div>{t("ADDRESS_SHOULD_START")}</div>
                </div>
              </div>
            </div>
        
            <div className="flex gap-2 pt-4">
              <button
                onClick={handleSubmit}
                disabled={!isFormValid() || !isValidAddress(newWallet.address)}
                className="flex-1 bg-blue-500 text-white rounded-lg py-3 font-medium hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
              >
                {t("ADD_WALLET")}
              </button>
              <button
                onClick={onClose}
                className="flex-1 bg-gray-200 text-gray-800 rounded-lg py-3 font-medium hover:bg-gray-300 transition-colors"
              >
                {t("CANCEL")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default AddWalletForm;